import { useSelector, useDispatch } from "react-redux";
import CartItem from "./CartItem";
import { clearCart } from "../utils/cartSlice";
import emptyCart from "../assets/img/emptyCart.png";
import { Link } from "react-router-dom";
import { useContext } from "react";
import UserContext from "../utils/UserContext";
import LoginPrompt from "./LoginPrompt";

const Cart = () => {
  const cartItems = useSelector((store) => store.cart.items);
  const orderTotal = cartItems.reduce(
    (acc, curr) => acc + (curr.price / 100) * curr.quantity,
    0
  );

  const {user} = useContext(UserContext);

  const dispatch = useDispatch();
  const clearCartHandler = () => {
    dispatch(clearCart());
  };

  if (cartItems.length === 0) {
    return (
      <div className="w-64 sm:w-80 mx-auto text-center">
        <img src={emptyCart} />
        <h5 className="text-base sm:text-xl text-slate-800 font-semibold">
          Your cart is empty
        </h5>
        <Link to="/">
          <button className="text-xs sm:text-base bg-cyan-500 my-6 px-4 py-2 text-white font-semibold">
            SEE RESTAURANTS NEAR YOU
          </button>
        </Link>
      </div>
    );
  }

  return (
    <div className="grid w-4/5 mx-auto grid-cols-1 sm:grid-cols-2 mt-4 text-slate-800">
      {/* Login prompt if not logged in inorder to place order */}
      {user.name === "" && <LoginPrompt/>}

      {/* Cart section */}
      <div className="h-fit shadow-md rounded-md w-full sm:w-4/5 mx-auto pt-2">
        <div className="text-right px-4">
          <button
            className="bg-red-400 px-2 py-1 rounded-full text-xs font-semibold"
            onClick={() => clearCartHandler()}
          >
            Clear Cart
          </button>
        </div>

        {cartItems.map((item) => (
          <CartItem key={item.id} item={item} />
        ))}
        <div className=" bg-cyan-500 rounded-t-full text-center font-semibold py-1">
          To Pay &#8377;{orderTotal}
        </div>

        {/* Only authenticated user can place order */}
        {user.name !== "" && (
          <button className="w-full shadow rounded-b-md p-2 bg-slate-800 text-white font-semibold">
            Place order
          </button>
        )}
      </div>
    </div>
  );
};

export default Cart;
